import { Component, Input /* , OnDestroy, OnInit */, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormDateTimeField } from '@grupo-constant/next-dtype/form';
// import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
// import { Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DtypeDatepickerFieldComponent } from '../datepicker-field/datepicker-field.component';
import { DtypeTimepickerFieldComponent } from '../timepicker-field/timepicker-field.component';

@Component({
    selector: 'datetimepicker-field-component',
    templateUrl: './datetimepicker-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DtypeDatepickerFieldComponent, DtypeTimepickerFieldComponent]
})
export class DtypeDatetimepickerFieldComponent implements DTypeFormFieldComponent/* , OnInit, OnDestroy */ {

    @Input() field: DTypeFormDateTimeField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    // private _unsubscribeAll = new Subject<void>();

    constructor() { }

    // ngOnInit() {
    //     // TODO asignar bien el valor de al fecha
    //     this.field.dateField.control.valueChanges
    //         .pipe(takeUntil(this._unsubscribeAll))
    //         .subscribe(value => {
    //             this.field.control.setValue(value);
    //         });

    //     // TODO asignar bien el valor de las horas
    //     this.timeControl.valueChanges
    //         .pipe(takeUntil(this._unsubscribeAll))
    //         .subscribe(value => {
    //             // this.field.control.setValue(value);
    //         });

    //     const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
    //     if (readonlyOnUpdate && this.isUpdate) {
    //         this.field.readonly = true;
    //     }
    // }

    // ngOnDestroy() {
    //     this._unsubscribeAll.next();
    //     this._unsubscribeAll.complete();
    // }

}
